import { PacketValueSerialType } from "../../../enum/PacketValueSerialType";
import Vector2 from "../../../math/Vector2";
import { Random } from "../../../util/Random";
import Bullet from "../../Bullet";
import Gun from "../../Gun";
import Player from "../../Player";

export default class ScatterRifle extends Gun {
    spreadAngle = 0.2618;

    constructor(player: Player) {
        super(player, {
            damage: 5,
            fireRate: 10,
            magSize: 50,
            reloadTime: 1.5,
            bulletSpeed: 225,
            mouseTrigger: 0
        });
    }

    onShoot(): void {
        //spray
        const lT = this.player.transform.rotation.rotate(-this.spreadAngle/2).angle;
        const rT = lT + this.spreadAngle;

        

        for (let i = 0; i < 3; i++) {
            const vec = Vector2.fromRadians(Random.float(lT, rT));
            const pos = this.player.transform.position.add(vec.scale(this.player.size + 4));
            const vel = this.player.velocity.add(vec.scale(this.bulletSpeed));

            this.player.engine.createBulletForAll(pos, vel, [
                {
                    key: "team",
                    value: this.player.team || "",
                    type: PacketValueSerialType.String
                },
                {
                    key: "damage",
                    value: this.damage,
                    type: PacketValueSerialType.Byte
                },
                {
                    key: "ownerName",
                    value: this.player.name,
                    type: PacketValueSerialType.String
                },
            ]);
        }

        

    }
    // onShoot(): void {
    //     //fixed 3 shot
    //     const lV = this.player.transform.rotation.rotate(-this.spreadAngle/2);
    //     const rV = this.player.transform.rotation.rotate(this.spreadAngle/2);

    //     for (const vec of [lV, this.player.transform.forward, rV]) {
    //         const pos = this.player.transform.position.add(vec.scale(this.player.size + 4));
    //         const vel = this.player.velocity.add(vec.scale(this.bulletSpeed));

    //         this.player.engine.createBulletForAll(pos, vel, [
    //             {
    //                 key: "team",
    //                 value: this.player.team,
    //                 type: PacketValueSerialType.String
    //             },
    //             {
    //                 key: "damage",
    //                 value: this.damage,
    //                 type: PacketValueSerialType.Byte
    //             },
    //             {
    //                 key: "ownerName",
    //                 value: this.player.name,
    //                 type: PacketValueSerialType.String
    //             },
    //         ]);
    //     }

    // }

}